import { useTrip } from "@/lib/store";
import { HotelCard } from "@/components/HotelCard";
import { SubHeader } from "../More";

export default function Stays() {
  const { trip } = useTrip();
  return (
    <div className="pb-8">
      <SubHeader eyebrow="Stays" title="Where we're sleeping" />
      <p className="mt-2 text-sm text-[var(--ink-muted)]">Four hotels, nine nights. Every card has the address in Chinese for taxis.</p>
      <div data-testid="stays-list" className="mt-4 grid gap-4 md:grid-cols-2">
        {trip.hotels.map((h) => <HotelCard key={h.id} hotel={h} />)}
      </div>
    </div>
  );
}
